// extracted by mini-css-extract-plugin
export default {"contactSection":"contact-form_contactSection__p5b0J","contactForm":"contact-form_contactForm__0FPRl","status":"contact-form_status__4DPpn"};